import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "ant_cookie_consent";

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch (e) {
      setShow(true);
    }
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] p-3 sm:p-4" data-testid="cookie-consent">
      <div className="max-w-4xl mx-auto rounded-2xl border border-[#00E676]/25 bg-[#0B120E]/95 backdrop-blur-xl shadow-[0_10px_40px_rgba(0,0,0,0.6)] p-5">
        <div className="flex items-start gap-3">
          <span className="p-2 rounded-xl bg-[#00E676]/10 text-[#39FF14] shrink-0"><Cookie size={18} /></span>
          <div className="flex-1">
            <div className="font-bold text-white text-sm mb-1">Vos cookies, votre choix</div>
            <p className="text-xs text-[#A1B5A8] leading-relaxed">
              Nous utilisons des cookies strictement nécessaires au fonctionnement du site (authentification, sécurité, session). Avec votre accord, nous pouvons également mesurer l'audience de façon anonyme. Vous pouvez accepter ou refuser librement, refuser est aussi simple qu'accepter. En savoir plus dans notre{" "}
              <Link to="/politique-confidentialite" className="text-[#39FF14] hover:underline">politique de confidentialité</Link>.
            </p>
          </div>
        </div>
        <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:justify-end">
          <button onClick={() => choose("refused")} data-testid="cookie-refuse" className="px-5 py-2 rounded-lg text-sm font-semibold text-white bg-[#131F17] border border-[#00E676]/20 hover:border-[#00E676]/50 transition-colors">
            Tout refuser
          </button>
          <button onClick={() => choose("accepted")} data-testid="cookie-accept" className="px-5 py-2 rounded-lg text-sm font-bold text-[#04180a] bg-gradient-to-r from-[#00E676] to-[#39FF14]">
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
}
